<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },

  spritePath: {
    type: String,
    default: '/icons/centourio_svg_sprite.svg',
  },
});
</script>

<template>
  <svg>
    <use :xlink:href="`${spritePath}#${props.name}`"></use>
  </svg>
</template>
